import type { ChatChannelType } from '@frontend/api';

export const ANNOTATION_TOOL_TYPES = {
  FEATURE_TOOL: 'FEATURE_TOOL',
  MEASUREMENT_TOOL: 'MEASUREMENT_TOOL',
  PDF_HIGHLIGHT_TOOL: 'PDF_HIGHLIGHT_TOOL',
  SELECTOR_TOOL: 'SELECTOR_TOOL',
} as const;

export const CHANNEL_TYPES = {
  ACTIONS: 'actions',
  MSC: 'msc',
  PENN: 'penn',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const satisfies Record<string, ChatChannelType>;

export const CHAT_DRAWER_STATE = {
  EXTERNAL: 'EXTERNAL',
  TEAM: 'TEAM',
  REQS_REVIEW: 'REQS_REVIEW',
} as const;
